import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Flex, header3SemiBold } from '@ubeya/shared-web/components';

const Wrapper = styled(Flex)`
  flex: 1;
  padding: 40px 15px 20px;
`;

const Title = styled.div`
  ${header3SemiBold}
  letter-spacing: 2.25px;
  margin-right: auto;
`;

const EmployeeCommentsHeader = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Title> {t('personalSettings')} </Title>
    </Wrapper>
  );
};

export default React.memo(EmployeeCommentsHeader);
